var _path, _line, _polyline;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeePage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.912,12.454c.011,1.393-.007,2.787-.056,4.18l-.019.541c-.078,2.252-1.885,4.059-4.137,4.137h-.028c-2.614.092-5.231.092-7.845,0h0c-2.251-.079-4.057-1.885-4.136-4.136l-.018-.518c-.079-2.279-.079-4.56,0-6.839l.018-.517c.079-2.251,1.886-4.058,4.137-4.136h.039c1.543-.055,3.088-.077,4.632-.066"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20.448,
    y1: 3.556,
    x2: 10.188,
    y2: 13.816
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "13.406 2.619 21.386 2.619 21.386 10.618"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeePage);
export default __webpack_public_path__ + "static/media/see-page.60e6f5c07e1e7e7f26db28898e14eb0f.svg";
export { ForwardRef as ReactComponent };